module.exports = __webpack_public_path__ + "static/img/isclanjenje1.df38d39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kup/tutorial/isclanjenje1.png
// module id = G9Qs
// module chunks = 0